import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import css from "./status.module.scss";

const Status = ({ isPrivate, isDraft }) => {
  const { t } = useTranslation();
  return (
    <div className={css.wrapper}>
      {isPrivate && (
        <Inline className={css.tag}>
          <Icon name="hidden" />
          {t("private")}
        </Inline>
      )}
      {isDraft && (
        <Inline className={css.tag}>
          <Icon name="edit" />
          {t("draft")}
        </Inline>
      )}
    </div>
  );
};

Status.propTypes = {
  isPrivate: PropTypes.bool,
  isDraft: PropTypes.bool
};
export default Status;
